const ArrowClockwise = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='currentColor' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 2.99992C5.23858 2.99992 3 5.2385 3 7.99992C3 10.7613 5.23858 12.9999 8 12.9999C10.7614 12.9999 13 10.7613 13 7.99992C13 7.25449 12.8372 6.54845 12.5457 5.91426C12.4304 5.66335 12.5403 5.36646 12.7912 5.25113C13.0421 5.1358 13.339 5.24571 13.4543 5.49661C13.8048 6.25915 14 7.10742 14 7.99992C14 11.3136 11.3137 13.9999 8 13.9999C4.68629 13.9999 2 11.3136 2 7.99992C2 4.68621 4.68629 1.99992 8 1.99992V2.99992Z'
      fill='currentColor'
    />
    <path
      d='M8 4.46616V0.533681C8 0.321722 8.24721 0.205932 8.41005 0.341626L10.7695 2.30787C10.8895 2.40781 10.8895 2.59203 10.7695 2.69198L8.41005 4.65822C8.24721 4.79391 8 4.67812 8 4.46616Z'
      fill='currentColor'
    />
  </svg>
);

export default ArrowClockwise;
